import { Flex as PandaFlex } from '@repo/themes/styled-system/jsx';
import { flex } from '@repo/themes/styled-system/patterns';
import type { SystemProperties } from '@repo/themes/styled-system/types';
import { Slot } from '@radix-ui/react-slot';

interface FlexProps {
  align?: SystemProperties['alignItems'];
  justify?: SystemProperties['justifyContent'];
  direction?: SystemProperties['flexDirection'];
  wrap?: SystemProperties['flexWrap'];
  basis?: SystemProperties['flexBasis'];
  grow?: SystemProperties['flexGrow'];
  shrink?: SystemProperties['flexShrink'];
  asChild?: boolean;
  children?: React.ReactNode;
  gap?: SystemProperties['gap'];
  height?: SystemProperties['height'];
  width?: SystemProperties['width'];
  padding?: SystemProperties['padding'];
  backgroundColor?: SystemProperties['backgroundColor'];
  rounded?: SystemProperties['borderRadius'];
  className?: string;
  style?: object;
}

const Flex = (props: FlexProps): React.JSX.Element => {
  const { children, asChild, ...otherProps } = props;
  if (asChild) {
    return <Slot className={flex({ ...otherProps })}>{children}</Slot>;
  } else {
    return <PandaFlex {...otherProps}>{children}</PandaFlex>;
  }
};

export default Flex;
